var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5875 26.9999H6.00001C5.73479 26.9999 5.48044 26.8945 5.2929 26.707C5.10536 26.5195 5.00001 26.2651 5.00001 25.9999V20.4124C4.99955 20.2825 5.02471 20.1539 5.07404 20.0338C5.12338 19.9136 5.19591 19.8044 5.28751 19.7124L20.2875 4.71239C20.3806 4.61791 20.4915 4.54287 20.6138 4.49165C20.7361 4.44044 20.8674 4.41406 21 4.41406C21.1326 4.41406 21.2639 4.44044 21.3862 4.49165C21.5085 4.54287 21.6195 4.61791 21.7125 4.71239L27.2875 10.2874C27.382 10.3804 27.457 10.4914 27.5082 10.6137C27.5595 10.736 27.5858 10.8673 27.5858 10.9999C27.5858 11.1325 27.5595 11.2638 27.5082 11.3861C27.457 11.5084 27.382 11.6193 27.2875 11.7124L12.2875 26.7124C12.1955 26.804 12.0863 26.8765 11.9661 26.9259C11.846 26.9752 11.7174 27.0003 11.5875 26.9999V26.9999Z",
    stroke: "#0C3A25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8L24 15",
    stroke: "#0C3A25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.ebac33862cfa6924fe78a859e2322822.svg";
export { ForwardRef as ReactComponent };